var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"initial",style:({width: _vm.width + 'px' , height: _vm.height+'px'})},[_c('span',{style:({lineHeight:_vm.height+'px',fontSize:_vm.size+'px'})},[_vm._v(_vm._s(_vm.bigName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }